import { saveBookedDemo } from "../repo/saveBookedDemo";

export const bookDemoService = async (demoDetails) => {
  const res = await saveBookedDemo(demoDetails);
  return res;
};
